import { render, staticRenderFns } from "./TakeawayAnnouncementHead.vue?vue&type=template&id=c64c0e10&scoped=true&"
import script from "./TakeawayAnnouncementHead.vue?vue&type=script&lang=js&"
export * from "./TakeawayAnnouncementHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64c0e10",
  null
  
)

export default component.exports